module.exports = __webpack_public_path__ + "static/media/065-new-document.aad7dda9.svg";